(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-affiliate-folding-panel"] && !Shopify.designMode) return;
  try {
     
class AddFoldingPanelWithImage extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let oLis = this.querySelectorAll(".uafpwi-li")
    // let oImgs = this.querySelectorAll(".uafpwi-img-wrap")
    let oBtns = this.querySelectorAll(".uafpwi-item-header")
    let oContents = this.querySelectorAll(".uafpwi-content")
    let oMains = this.querySelectorAll(".uafpwi-main")
    oBtns.forEach((item,i) => {
      item.addEventListener("click",() => {
        if (oLis[i].getAttribute('show') == "1") {
          oContents[i].style.height = "0"
          // oImgs[i].style.display = "none"
          oLis[i].setAttribute('show', "")
        } else {
          oContents.forEach(b => {
            b.style.height = '0'
          })
          oLis.forEach(b => {
            b.setAttribute('show', "")
          })
          // oImgs.forEach(b => {
          //   b.style.display = 'none'
          // })
          let height = oMains[i].offsetHeight
          oContents[i].style.height = height + "px"
          // oImgs[i].style.display = "block"
          oLis[i].setAttribute('show', "1")
        }
      })
    })
    if (oBtns[0]) {
      oBtns[0].click()
    }
  }
}
if (!customElements.get('aff-folding-panel-with-image')) {
  customElements.define('aff-folding-panel-with-image', AddFoldingPanelWithImage);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-c41-folding-panel-with-media"] && !Shopify.designMode) return;
  try {
     
class FoldingPanelWithImage extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let oLis = this.querySelectorAll(".ucfpw-li")
    let oImgs = this.querySelectorAll(".ucfpw-img-wrap")
    let oBtns = this.querySelectorAll(".ucfpw-item-header")
    let oContents = this.querySelectorAll(".ucfpw-content")
    let oMains = this.querySelectorAll(".ucfpw-main")
    oBtns.forEach((item,i) => {
      item.addEventListener("click",() => {
        if (oLis[i].getAttribute('show') == "1") {
          oContents[i].style.height = "0"
          // oImgs[i].style.display = "none"
          oLis[i].setAttribute('show', "")
        } else {
          oContents.forEach(b => {
            b.style.height = '0'
          })
          oLis.forEach(b => {
            b.setAttribute('show', "")
          })
          oImgs.forEach(b => {
            b.style.display = 'none'
          })
          let height = oMains[i].offsetHeight
          oContents[i].style.height = height + "px"
          oImgs[i].style.display = "block"
          oLis[i].setAttribute('show', "1")
        }
      })
    })
    if (oBtns[0]) {
      oBtns[0].click()
    }
  }
}
if (!customElements.get('ql-folding-panel-with-image')) {
  customElements.define('ql-folding-panel-with-image', FoldingPanelWithImage);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-contact-faq"] && !Shopify.designMode) return;
  try {
     
class ContactFaqs extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let oLis = this.querySelectorAll(".ucfa-li")
    let oBtns = this.querySelectorAll(".ucfa-item-header")
    let oContents = this.querySelectorAll(".ucfa-content")
    let oMains = this.querySelectorAll(".ucfa-main")
    oBtns.forEach((item,i) => {
      item.addEventListener("click",() => {
        if (oLis[i].getAttribute('show') == "1") {
          oContents[i].style.height = "0"
          oLis[i].setAttribute('show', "")
        } else {
          // oContents.forEach(b => {
          //   b.style.height = '0'
          // })
          // oLis.forEach(b => {
          //   b.setAttribute('show', "")
          // })
          let height = oMains[i].offsetHeight
          oContents[i].style.height = height + "px"
          oLis[i].setAttribute('show', "1")
        }
      })
    })
    if (oBtns[0]) {
      // oBtns[0].click()
    }
  }
}
if (!customElements.get('ubt-contact-faqs')) {
  customElements.define('ubt-contact-faqs', ContactFaqs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-folding-panel-with-media"] && !Shopify.designMode) return;
  try {
     
class FoldingPanelWithImage extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let oLis = this.querySelectorAll(".ufpwi-li")
    let oImgs = this.querySelectorAll(".ufpwi-img-wrap")
    let oBtns = this.querySelectorAll(".ufpwi-item-header")
    let oContents = this.querySelectorAll(".ufpwi-content")
    let oMains = this.querySelectorAll(".ufpwi-main")
    oBtns.forEach((item,i) => {
      item.addEventListener("click",() => {
        if (oLis[i].getAttribute('show') == "1") {
          oContents[i].style.height = "0"
          // oImgs[i].style.display = "none"
          oLis[i].setAttribute('show', "")
        } else {
          oContents.forEach(b => {
            b.style.height = '0'
          })
          oLis.forEach(b => {
            b.setAttribute('show', "")
          })
          oImgs.forEach(b => {
            b.style.display = 'none'
          })
          let height = oMains[i].offsetHeight
          oContents[i].style.height = height + "px"
          oImgs[i].style.display = "block"
          oLis[i].setAttribute('show', "1")
        }
      })
    })
    if (oBtns[0]) {
      oBtns[0].click()
    }
  }
}
if (!customElements.get('ql-folding-panel-with-image')) {
  customElements.define('ql-folding-panel-with-image', FoldingPanelWithImage);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-home-faqs"] && !Shopify.designMode) return;
  try {
     
class FoldingPanelWithImage1 extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let oLis = this.querySelectorAll(".hfaq-li")
    let oImgs = this.querySelectorAll(".hfaq-img-wrap")
    let oBtns = this.querySelectorAll(".hfaq-item-header")
    let oContents = this.querySelectorAll(".hfaq-content")
    let oMains = this.querySelectorAll(".hfaq-main")
    oBtns.forEach((item,i) => {
      item.addEventListener("click",() => {
        if (oLis[i].getAttribute('show') == "1") {
          oContents[i].style.height = "0"
          // oImgs[i].style.display = "none"
          oLis[i].setAttribute('show', "")
        } else {
          oContents.forEach(b => {
            b.style.height = '0'
          })
          oLis.forEach(b => {
            b.setAttribute('show', "")
          })
          // oImgs.forEach(b => {
          //   b.style.display = 'none'
          // })
          let height = oMains[i].offsetHeight
          oContents[i].style.height = height + "px"
          // oImgs[i].style.display = "block"
          oLis[i].setAttribute('show', "1")
        }
      })
    })
    if (oBtns[0]) {
      oBtns[0].click()
    }
  }
}
if (!customElements.get('ql-folding-panel-with-image1')) {
  customElements.define('ql-folding-panel-with-image1', FoldingPanelWithImage1);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-home-tab-with-video"] && !Shopify.designMode) return;
  try {
    
  class Swiper1ProductCards extends HTMLElement {
    constructor() {
      super();
      this.swiper = null
      this.tabSwiper = null
      this.tabclassName = ".tab-swiper-" + this.getAttribute("sid")
      this.className = ".swiper-" + this.getAttribute("sid")
      this.oTabs = this.querySelectorAll('.lsp8-tab-li')
      // this.playIcons = this.querySelectorAll('.lsp8-icon')
      this.prevImgs = this.querySelectorAll('.lsp8-pre-img-box')
      this.videos = this.querySelectorAll('.lsp8-img-wrap>video')

      this.hadPlay = false
      document.addEventListener('DOMContentLoaded', () => {
        this.init()
        this.dealPlayStatus()
      })
    }
    init () {
      this.tabSwiper = new Swiper(this.tabclassName, {
        loop: true,
        slidesPerView: "auto",
        // slidesPerView: 3,
        centeredSlides: true,
        allowTouchMove: false,
        // simulateTouch: false,
        // slideToClickedSlide: true,
        // thumbs: {
        //   swiper: this.swiper
        // },
      });
      this.tabSwiper.on('realIndexChange', (e) => {
        // console.log('realIndexChange')
        let index = e.realIndex
        setTimeout(() => {
          if (this.swiper.realIndex == index) {
            return
          }
          // this.swiper.slideToLoop(index);
        }, 300);
      })

      // this.tabSwiper.on('activeIndexChange', (e) => {
      //   console.log('activeIndexChange', e)
      // })
      // this.tabSwiper.on('slideChange', (e) => {
      //   console.log('slideChange', e)
      // })

      this.oTabs.forEach((card) => {  
        card.addEventListener('click', (e) => {
          let currentIndex = card.getAttribute('data-swiper-slide-index')
          if (currentIndex == this.swiper.realIndex) {
            return
          }
          let index = card.closest('.swiper-slide').getAttribute('data-swiper-slide-index')
          if (this.swiper.realIndex == index) {
            return
          }
          // this.swiper.slideToLoop(index)
        })
      })

      this.swiper = new Swiper(this.className, {
        loop: true,
        spaceBetween: 12,
        slidesPerView: "auto",
        centeredSlides: true,
        // autoplay: {
        //   delay: 5000, 
        //   disableOnInteraction: false,
        // },
        thumbs: {
          swiper: this.tabSwiper
        },
        breakpoints: {
          1024: {
            spaceBetween: 20,
            slidesPerView: "auto",
          }
        },
        // pagination: {
        //   el: '.lsp8-pagination',
        //   renderBullet: function (index, className) {
        //     // return '<span class="' + className + '">' + "</span>";
        //     return `
        //       <div class="${className} ubt-pagination-dot">
        //         <div class="pagination-dot-bar"></div>
        //       </div>
        //     `
        //   }
        // },
        navigation: {
          nextEl: '.section-' + this.getAttribute("sid") + ' .ubt-arrow-next',
          prevEl: '.section-' + this.getAttribute("sid") + ' .ubt-arrow-prev',
        },
      });
      this.swiper.on('realIndexChange', (e) => {
        let index = e.realIndex
        if (this.tabSwiper.realIndex == index) {
          return
        }
        this.tabSwiper.slideToLoop(index);


        this.videos.forEach((item,i) => {
          item.pause()
        })
        setTimeout(() => {
          let currentVideo = this.querySelector(".swiper-slide-active video")
          if (currentVideo && this.hadPlay) { currentVideo.play() }
        }, 400);
      })
      this.swiper.on('autoplayStart', () => {
        this.querySelectorAll('.pagination-dot-bar').forEach(bar => {
          bar.style.animationPlayState = 'running';
        });
      });
      this.swiper.on('autoplayStop', () => {
        this.querySelectorAll('.pagination-dot-bar').forEach(bar => {
          bar.style.animationPlayState = 'paused';
        });
      });
    }
    dealPlayStatus () {
      // this.prevImgs.forEach((item,i) => {
      //   item.addEventListener("click", () => {
      //     this.playIcons[i].click()
      //   })
      // })
      this.prevImgs.forEach((item,i) => {
        item.addEventListener("click", () => {
          if (this.videos[i]) {
            this.swiper.slideToLoop(i);
            this.videos[i].play()
          }
        })
      })

      this.videos.forEach((item,i) => {
        item.addEventListener("play", () => {
          // console.log(i, this.prevImgs)
          if (this.prevImgs[i]) {
            this.prevImgs[i].remove()
          }
          if (this.prevImgs[i]) {
            this.prevImgs[i].remove()
          }
          this.hadPlay = true
        });
        item.addEventListener("ended", () => {
          let index = i + 1
          let l = this.oTabs.length
          if (index === l) {
            index = 0
          }
          this.swiper.slideToLoop(index);
        });
      })

      let observe = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          let currentVideo = this.querySelector(".swiper-slide-active video")
          // console.log(currentVideo, this.hadPlay)
          if (entry.isIntersecting) {
            if (this.hadPlay) {
              // currentVideo.play()
            }
          } else {
            if (this.hadPlay) {
              currentVideo.pause()
            }
          }
        });
      }, { threshold: 0 });

      observe.observe(this.querySelector(".prin-wrap"));

    }
  }
  if (!customElements.get('q-swiper-8-tab')) {
    customElements.define('q-swiper-8-tab', Swiper1ProductCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-main-product"] && !Shopify.designMode) return;
  try {
    
    class UProductPage extends HTMLElement {
      constructor() {
          super();
          this.oLeftTops = this.querySelectorAll(".ump-left-top")
          this.oLeftSlicks = this.querySelectorAll(".ump-left-img-slick")
          this.oLeftTabs = this.querySelectorAll(".ump-left-media-tabs")
          this.oLeftDetainPop = document.querySelector(".ubt_leftpop_des")
          document.addEventListener('DOMContentLoaded', () => {
            this.init()
          })
      }
      init () {
          // var swiper = new Swiper('.ump-left-bottom-swiper', {
          //   slidesPerView: "auto",
          //   spaceBetween: 14,
          //   loop: false,
          //   // navigation: {
          //   //   nextEl: '.section-{{ section.id }} .ubt-arrow-next',
          //   //   prevEl: '.section-{{ section.id }} .ubt-arrow-prev',
          //   // },
          //   // breakpoints: {
          //   //   1024: {
          //   //     spaceBetween: 20,
          //   //   }
          //   // }
          // });
          this.oLeftTabs.forEach((item,i) => {
              item.addEventListener("click", () => {
                  this.tabClick(i, item)
              })
          })

          this.oLeftSlicks.forEach((item, i) => {
              let children = item.querySelectorAll(".swiper-slide")
              if (children.length > 1) {
                let swiper = new Swiper(`.ump-slider-${i}`, {
                  loop: true,
                  navigation: {
                    nextEl: `.ump-slider-${i} .ubt-arrow-next`,
                    prevEl: `.ump-slider-${i} .ubt-arrow-prev`,
                  },
                });
                swiper.on('realIndexChange', (e) => {
                  // console.log(e)
                  let realIndex = e.realIndex
                  this.querySelectorAll(".ump-slide-current")[i].innerText = realIndex + 1
                });
              }
          })


          const isScrollFn = () => {
              const wrap = this.querySelector('.ump-left-bottom-left');
              const scroller = this.querySelector('.ump-left-bottom-left-scroller');
              // console.log(scroller.scrollWidth, scroller.clientWidth)
              const isScrolled = scroller.scrollWidth > scroller.clientWidth;
              if (isScrolled) {
                  wrap.classList.add("isScroll")
              } else {
                  wrap.classList.remove("isScroll")
              }
          }
          isScrollFn()
          window.addEventListener("resize", isScrollFn)
      }
      tabClick (i, item) {
          this.oLeftTops.forEach(t => { t.classList.remove("ump-act") })
          this.oLeftTabs.forEach(t => { t.classList.remove("ump-act") })
          this.oLeftTops[i].classList.add('ump-act')
          this.oLeftTabs[i].classList.add('ump-act')

          let allVideo = this.querySelectorAll(".ump-left-img-vid")
          if (allVideo) {
              allVideo.forEach(v => {
                  v.pause()
              })
          }
          
          if (this.oLeftTabs[i].getAttribute("block-type") == "product_media_video") {
              let vid = this.oLeftTops[i].querySelectorAll(".ump-left-img-vid")
              vid.forEach(v => {
                  if (window.getComputedStyle(v).display !== "none") {
                      v.play()
                  }
              })
          }
          let oWrap = this.querySelector(".ump-left-bottom-left-scroller")
          if (oWrap && item) {
            const itemRect = item.getBoundingClientRect();
            const wrapRect = oWrap.getBoundingClientRect();
            const scrollLeft = oWrap.scrollLeft;
            const itemCenter = item.offsetLeft + item.offsetWidth / 2;
            const wrapCenter = oWrap.clientWidth / 2;
            oWrap.scrollTo({
              left: itemCenter - wrapCenter,
              behavior: 'smooth'
            });
          }
          

      }
    }
    if (!customElements.get('ubt-product-page')) {
        customElements.define('ubt-product-page', UProductPage);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-product-anchor"] && !Shopify.designMode) return;
  try {
    
class ProductAnchor extends HTMLElement {
  constructor() {
    super();
    this.navBtns = this.querySelectorAll(".upan-top-btn")
    this.init()
  }
  init () {
    window.addEventListener("scroll", () => {
      let offset = 0
      if (window.innerWidth <= 1024) {
        offset = 0
      }
      let t = document.documentElement.scrollTop + offset   //根据导航栏高度调整
      let oWrap = this.querySelector('.upan-wrap')
      let oFixed = this.querySelector('.upan-fixed')
      let top = oWrap.offsetTop
      if (top < t) {
        oFixed.setAttribute("show", "1")
      } else {
        oFixed.setAttribute("show", "")
      }

      let oFixedTop = oFixed.offsetTop
      let header = document.querySelector('.ubt-header')
      if ((document.documentElement.scrollTop + 50) > oFixedTop) {
        header.classList.add('header-top--100')
      } else {
        header.classList.remove('header-top--100')
      }
    })

    let ob = new IntersectionObserver((e) => {
      let entry = e[0]
      if (entry.isIntersecting) {
        this.navBtns.forEach((ite) => {
          ite.setAttribute("show", "")
        })
        this.navBtns.forEach((item,i) => {
          // console.log(item.getAttribute('data-id'),entry.target.getAttribute("id"))
          if (item.getAttribute('data-id') === entry.target.getAttribute("id")) {
            item.setAttribute('show', "1")
            navScrollToCenter(item)
          }
        })
      }
    }, {
      threshold: 0.5
    })

    this.navBtns.forEach((item,i) => {
      let id = item.getAttribute("data-id")
      let dom = document.querySelector("#" + id)
      if (dom) {
        ob.observe(dom)
      }
      item.addEventListener("click", () => {
        let top = 0
        if (id == 'reviews') {
          dom = document.querySelector("#reviews") //改成插件的css选择器
          // top -= 100
        }
        top += dom.offsetTop
        let offset = -50
        if (window.innerWidth <= 1600) {
          offset = -30
        }
        if (window.innerWidth <= 1024) {
          offset = 0
        }
        window.scrollTo({
          top: top - offset,
          behavior: "smooth"
        })
      })
    })

    // 单独监听reviews，后台的id填reviews
    let reviewOb = new IntersectionObserver((e) => {
      e.forEach(entry => {
        if (entry.isIntersecting) {
          navBtns.forEach((ite) => {
            ite.setAttribute("show", "")
          })
          let item = document.querySelector('[data-id="reviews"]')
          item.setAttribute('show', "1")
          navScrollToCenter(item)
        }
      })
    }, {
      threshold: 0.5
    })
    // reviews插件的元素渲染比较慢，需要加定时
    setTimeout(() => {
      let oReview = document.querySelector(".AirReviews-CarouselWrapper")
      if (oReview) {
        reviewOb.observe(oReview)
      }
    }, 2000)

    function navScrollToCenter (item) {
      const lanBg = document.querySelector('.upan-top-ul');
      const rect = item.getBoundingClientRect();
      const bgRect = lanBg.getBoundingClientRect();
      const scrollLeft = lanBg.scrollLeft;
      const itemCenter = rect.left + rect.width / 2;
      const bgCenter = bgRect.left + bgRect.width / 2;
      lanBg.scrollLeft = scrollLeft + (itemCenter - bgCenter);
    }
  }
}
if (!customElements.get('q-product-anchor')) {
  customElements.define('q-product-anchor', ProductAnchor);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-product-two-image-comparison"] && !Shopify.designMode) return;
  try {
    
class QlTwoImageComparison extends HTMLElement {
  constructor() {
    super();
    // this.init()
  }
  init () {
    let imgcWrap = this.querySelector('.imgc-wrap')
    let imgcBox1 = this.querySelector('.imgc-box1')
    let imgcBtnWrap = this.querySelector('.imgc-btn-wrap')
    let imgcBtn = this.querySelector('.imgc-btn')

    imgcBtnWrap.addEventListener('mousedown', (e) => {
      let startX = e.clientX;
      let startLeft = imgcBtnWrap.offsetLeft;

      function onMouseMove(e) {
        let newLeft = startLeft + e.clientX - startX;
        if (newLeft < 0) newLeft = 0;
        if (newLeft > imgcWrap.clientWidth) newLeft = imgcWrap.clientWidth;
        let percent = newLeft / imgcWrap.clientWidth * 100
        if (percent < 3) percent = 3;
        if (percent > 97) percent = 97;
        imgcBtnWrap.style.left = `${percent}%`;
        imgcBox1.style.clipPath = `inset(0px 0px 0px ${percent}%)`;
      }
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', onMouseMove);
      }, { once: true });
    });

    imgcBtnWrap.addEventListener('touchstart', (e) => {
      e = e.touches[0]
      let startX = e.clientX;
      let startLeft = imgcBtnWrap.offsetLeft;

      function onMouseMove(e) {
        e = e.touches[0]
        let newLeft = startLeft + e.clientX - startX;
        if (newLeft < 0) newLeft = 0;
        if (newLeft > imgcWrap.clientWidth) newLeft = imgcWrap.clientWidth;
        let percent = newLeft / imgcWrap.clientWidth * 100
        if (percent < 3) percent = 3;
        if (percent > 97) percent = 97;
        imgcBtnWrap.style.left = `${percent}%`;
        imgcBox1.style.clipPath = `inset(0px 0px 0px ${percent}%)`;
      }
      document.addEventListener('touchmove', onMouseMove);
      document.addEventListener('touchend', () => {
        document.removeEventListener('touchmove', onMouseMove);
      }, { once: true });
    });

    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          imgcBox1.classList.add('imgc-box-animation');
          imgcBtnWrap.classList.add('imgc-btn-animation');
          observer.unobserve(imgcWrap);
        }
      });
    }, { threshold: 0.1 });
    observer.observe(imgcWrap);
  }
}
if (!customElements.get('ql-two-image-comparison')) {
  customElements.define('ql-two-image-comparison', QlTwoImageComparison);
}

  } catch(e) { console.error(e); }
})();
})();
